export var ETransportType;
(function (ETransportType) {
  ETransportType["Transport"] = "transport";
  ETransportType["Walk"] = "walk";
})(ETransportType || (ETransportType = {}));